// extracted by mini-css-extract-plugin
export default {"container":"TopBlock_container__D5WDD","title":"TopBlock_title__olSK5","subTitle":"TopBlock_subTitle__j3R7a","roundButtonBlock":"TopBlock_roundButtonBlock__ZE6t5"};